import React from 'react'
import {translate} from 'react-i18next'
import FormSubmitButton from '../logister-form/components/FormSubmitButton'
import {ruleRunner} from 'utils/validation/ruleRunner'
import {maxLength, required} from 'utils/validation/rules'
import Captcha from 'components/Captcha'
import {getLang} from 'utils/stringUtils'
import FormField from '../../login-form/LoginFormField'
import FormForgetLink from '../../login-form/LoginFormForgetLink'
import theme from 'theme'
import {ELEMENTS_IDS, LEGACY_PASSWORD_MAX_LENGTH} from 'const'
import {Label} from '../LogisterPageStyles'
import FieldLabel from 'components/field/FieldLabel'

const lang = getLang(window.location.search)

function HintedLoginForm({
  t,
  data = {},
  errors = {},
  touched = {},
  onChange,
  onSubmit,
  onBlur,
  onForgetPassword,
  nativeLoginError,
  loading,
  email,
  shouldShowCaptcha,
  isValid,
  isFederatedOnly,
}) {
  const passwordError = touched.password && errors.password

  const onCaptchaChange = value => onChange({target: {value, name: 'captchaToken'}}, false)

  return (
    <form onSubmit={onSubmit} noValidate autoComplete="on">
      <FieldLabel>{t('inputs.email')}</FieldLabel>
      <Label>{email}</Label>
      {!isFederatedOnly && (
        <>
          <FormField
            autoComplete="current-password"
            name="password"
            type="password"
            label={t('inputs.password')}
            value={data.password}
            onChange={onChange}
            onBlur={onBlur}
            error={passwordError}
            nativeLoginError={nativeLoginError}
            required
            autoFocus
            margin="-20px -20px 4px -20px !important"
            hinted
          />
          <FormForgetLink error={passwordError} nativeLoginError={nativeLoginError} onClick={onForgetPassword} />
        </>
      )}

      {shouldShowCaptcha && (
        <Captcha onChange={onCaptchaChange} hl={lang} error={touched.captchaToken && errors.captchaToken} />
      )}

      {!isFederatedOnly && (
        <FormSubmitButton
          loading={loading}
          disabled={!isValid}
          id={ELEMENTS_IDS.loginPage.loginNative}
          label="buttons.login"
          styleType={theme.logisterForm.submitButton}
          margin={0}
        />
      )}
    </form>
  )
}

export const validations = [ruleRunner('password', 'inputs.password', required, maxLength(LEGACY_PASSWORD_MAX_LENGTH))]

export {HintedLoginForm as PureHintedLoginForm}

export default translate()(HintedLoginForm)
